import React, { useState } from "react";
import ShippingCarrierList from "./ShippingCarrierList";
import ShippingZoneList from "./ShippingZoneList";

const ShippingManager: React.FC = () => {
  const [section, setSection] = useState<"carriers" | "zones">("carriers");

  return (
    <div className="space-y-4">
      <div className="flex gap-2 mb-4">
        <button
          className={`px-4 py-2 rounded text-sm font-medium ${section === "carriers" ? "bg-blue-600 text-white" : "bg-gray-100 text-gray-700 hover:bg-gray-200"}`}
          onClick={() => setSection("carriers")}
        >
          Transportadoras
        </button>
        <button
          className={`px-4 py-2 rounded text-sm font-medium ${section === "zones" ? "bg-blue-600 text-white" : "bg-gray-100 text-gray-700 hover:bg-gray-200"}`}
          onClick={() => setSection("zones")}
        >
          Zonas e Tarifas
        </button>
      </div>

      {section === "carriers" && <ShippingCarrierList />}
      {section === "zones" && <ShippingZoneList />}
    </div>
  );
};

export default ShippingManager;
